<mat-card class="p-0">
  <mat-card-title>
    <div class="card-title-text">
      Mostra Nominativi
    </div>
  </mat-card-title>
  <!--<mat-card-content style="width:720px!important">-->
  <mat-card-content  style="width:800px!important">
        <div fxLayout="row wrap">
          <div fxFlex.gt-sm="50%">
            <mat-form-field class="full-width">
              <input matInput
                     placeholder="Filtra"
                     [(ngModel)]="txtFiltra"
                     id="txtFiltra"
                     value=""
                     (keyup)='updateFilter($event)'>
            </mat-form-field>
          </div>

        </div>
        <div fxLayout="row wrap">
          <div fxFlex.gt-sm="100%">
            <ngx-datatable #grd
                           [rows]="lstElenco"
                           [columnMode]="'flex'"
                           [headerHeight]="50"
                           [footerHeight]="50"
                           [limit]="8"
                           [rowHeight]="'auto'">

              <ngx-datatable-column name="Nominativo"
                                    [flexGrow]="1.75"
                                    [sortable]="true"
                                    prop="Cognome">
                <ng-template let-row="row" ngx-datatable-cell-template>
                  {{ row?.Cognome }} {{ row?.Nome }}
                </ng-template>
              </ngx-datatable-column>

             
              <ngx-datatable-column name="Email"
                                    [flexGrow]="2"
                                    [sortable]="true"
                                    prop="Email">
                <ng-template let-row="row" ngx-datatable-cell-template>
                  <b>{{ row?.Email}}</b>
                  <br />
                  {{ row?.CodiceFiscale}}
                </ng-template>
              </ngx-datatable-column>

 

              <ngx-datatable-column name="" [flexGrow]="0.75">
                <ng-template let-row="row" ngx-datatable-cell-template>

                  <button mat-raised-button color="accent"
                          (click)="btnSalva(row.idUtentiProfilo)">
                    Aggiungi
                  </button>

                </ng-template>
              </ngx-datatable-column>

            </ngx-datatable>

          </div>

        </div>
      </mat-card-content>
    </mat-card>
    <div align="right">
      <button mat-raised-button color="accent"
              (click)="btnEsci()">
        Chiudi
      </button>
    </div>


    <style>

      .inserimento-form {
        min-width: 150px;
        max-width: 720px !important;
        width: 100%;
      }

      /* .full-width {
        width: 100%;
      }*/

      :host ::ng-deep .ngx-datatable .datatable-body .datatable-row-wrapper:nth-child(odd) {
        background-color: #DDDDDD !important;
      }

 
    </style>



